/** Prop definitions for the spawn menu.
 *  url: remote GLTF/GLB model URL loaded by clients
 *  Models are from Kenney (CC0) via pmndrs/market-assets and KhronosGroup
 */
export const PROPS = [
    { id: "barrel",   name: "Barrel",      icon: "🛢️",  mass: 20,  halfExtent: 0.5,
      url: "https://raw.githubusercontent.com/pmndrs/market-assets/main/files/models/barrel/model.gltf" },
    { id: "crate",    name: "Crate",       icon: "📦",  mass: 15,  halfExtent: 0.5,
      url: "https://raw.githubusercontent.com/pmndrs/market-assets/main/files/models/sci-fi-crate/model.gltf" },
    { id: "chest",    name: "Chest",       icon: "🗃️",  mass: 18,  halfExtent: 0.4,
      url: "https://raw.githubusercontent.com/pmndrs/market-assets/main/files/models/chest/model.gltf" },
    { id: "bench",    name: "Bench",       icon: "🪑",  mass: 12,  halfExtent: 0.5,
      url: "https://raw.githubusercontent.com/pmndrs/market-assets/main/files/models/bench/model.gltf" },
    { id: "ball",     name: "Cannonball",  icon: "⚽",  mass: 25,  halfExtent: 0.3,
      url: "https://raw.githubusercontent.com/pmndrs/market-assets/main/files/models/cannon-ball/model.gltf" },
    { id: "can",      name: "Soda Can",    icon: "🥫",  mass: 2,   halfExtent: 0.15,
      url: "https://raw.githubusercontent.com/pmndrs/market-assets/main/files/models/soda-can/model.gltf" },
    { id: "pot",      name: "Pot",         icon: "🍯",  mass: 8,   halfExtent: 0.3,
      url: "https://raw.githubusercontent.com/pmndrs/market-assets/main/files/models/pot/model.gltf" },
    { id: "tower",    name: "Tower",       icon: "🏰",  mass: 30,  halfExtent: 0.6,
      url: "https://raw.githubusercontent.com/pmndrs/market-assets/main/files/models/tower/model.gltf" },
    { id: "board",    name: "Board",       icon: "🪵",  mass: 5,   halfExtent: 0.3,
      url: "https://raw.githubusercontent.com/pmndrs/market-assets/main/files/models/cutting-board/model.gltf" },
    { id: "sword",    name: "Sword",       icon: "⚔️",  mass: 4,   halfExtent: 0.2,
      url: "https://raw.githubusercontent.com/pmndrs/market-assets/main/files/models/sword/model.gltf" },
];
